const container = document.querySelector('.js-scroll-el-container');
const scrollEls = document.getElementsByClassName('js-scroll-el');
const scrollImgCnt = Array.prototype.slice.call(document.querySelectorAll('.js-scroll-img'));
var windowHeight = window.innerHeight;
    
if(scrollEls){
    window.addEventListener('scroll', function() {    
        if(!container) return;
        const rect = container.getBoundingClientRect();
        var elemBot = rect.bottom;
        var elemHeight = container.offsetHeight; 
        var elemPos = (elemBot - elemHeight/2) - windowHeight/2;
        for (let i = 0; i < scrollEls.length; i++) {
            scrollEls[i].style.top = elemPos*0.7 + 'px';
        }
    });
}
if(scrollImgCnt.length){
    window.addEventListener('scroll', function() {  
        for (let i = 0; i < scrollImgCnt.length; i++) {
            const scrollImg = scrollImgCnt[i].querySelectorAll('img');
            const imgRect = scrollImgCnt[i].getBoundingClientRect();
            var imgBot = imgRect.bottom;
            var imgHeight = scrollImgCnt[i].offsetHeight;
            var imgPos = (imgBot - imgHeight/2) - windowHeight;
            for (let x = 0; x < scrollImg.length; x++) {
                var scaleNo = 1 + Math.abs(imgPos/8000);
                var cssTransform = scrollImg[x].style.transform;
                //console.log(scaleNo);
                //scrollImg[x].style.transform = cssTransform + ' scale(' + scaleNo + ')';
            }
            scrollImgCnt.splice(i, 1);
            i -= 1;
            //console.log(scrollImgCnt);
        }
    });
}